import { Check, Clock, MinusCircle, X } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import type { Notification } from "@/types/notification";

interface NotificationStatusBadgeProps {
  status: Notification["status"];
}

export function NotificationStatusBadge({ status }: NotificationStatusBadgeProps) {
  switch (status) {
    case "completed":
      return (
        <Badge variant="success">
          <Check aria-hidden="true" />
          Completed
        </Badge>
      );
    case "failed":
      return (
        <Badge variant="error">
          <X aria-hidden="true" />
          Failed
        </Badge>
      );
    case "skipped":
      return (
        <Badge variant="outline">
          <MinusCircle aria-hidden="true" />
          Skipped
        </Badge>
      );
    case "created":
    case "queued":
    default:
      return (
        <Badge variant="secondary">
          <Clock aria-hidden="true" />
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </Badge>
      );
  }
}
